<template>
    <div class="container">
        <h1 >UNTITLED</h1>
        <p class="lead">Short | 2019 | 9' | Color | German OS</p>

      <carousel per-page="1" navigation-enabled="true" autoplay="true" autoplay-timeout="7000">
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/Bildschirmfoto%202020-12-15%20um%2022.10.35.png?alt=media&token=66f54549-a9b0-45de-8629-96f876334fc7" class="d-block w-100">
        </slide>
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/Bildschirmfoto%202020-12-15%20um%2022.11.19.png?alt=media&token=1870dbc3-5789-473f-bceb-7f66816cbb74" class="d-block w-100" alt="...">
        </slide>
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/Bildschirmfoto%202020-12-15%20um%2022.12.37.png?alt=media&token=0feecf0d-4570-4a8a-9d38-bbd176c08f13" class="d-block w-100" alt="...">
        </slide>
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/Bildschirmfoto%202020-12-15%20um%2022.14.02.png?alt=media&token=87c6af80-2fe7-42b3-a48b-f2da3a2fbf06" class="d-block w-100" alt="...">
        </slide>

      </carousel>


<!--        <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/52.jpg?alt=media&token=1e0941ff-0beb-4486-9230-8d42e45fca92" class="img-fluid" alt="Responsive image">-->
        <p class="lead mt-4 mb-4">A pregnant man tries to get an abortion, but abortion is illegal in the world he lives in.</p>
<!--      <iframe src="https://player.vimeo.com/video/375487388" width="1066" height="600" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>-->

      <p class="lead mt-5 mb-4">
        <span class="font-weight-normal"> BY </span> <br>
        Anton von Heiseler <br>
        Florian Merz <br>
        Lucas Heinze <br>
        Antonia Paula Jacob <br>
        Julisa Pallesche <br>
        Angelina Hermann <br>
        Friederike Rost <br>
        Cecilia Kindermann <br>
        Oscar Zöllner <br><br>

        <span class="font-weight-normal"> WITH </span>  <br>

        Lorenz Maria Krieger<br>
        Paul Michael Stiehler

      </p>
    </div>
</template>

<script>
    export default {
        name: "untitled"
    }
</script>

<style scoped>

</style>
